import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function ComparisonTable() {
  const features = [{
    name: 'Álbum 2026 PDF',
    basic: true,
    history: true
  }, {
    name: 'Figuritas todos los equipos',
    basic: true,
    history: true
  }, {
    name: 'Figuritas especiales',
    basic: true,
    history: true
  }, {
    name: 'Instructivo de impresión',
    basic: true,
    history: true
  }, {
    name: 'Álbum + Figuritas Qatar 2022',
    basic: false,
    history: true
  }, {
    name: 'Álbum + Figuritas Rusia 2018',
    basic: false,
    history: true
  }, {
    name: 'Álbum + Figuritas Brasil 2014',
    basic: false,
    history: true
  }, {
    name: 'Álbum + Figuritas Sudáfrica 2010',
    basic: false,
    history: true
  }];
  return <section className="py-20 bg-gray-50" data-id="element-17">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-18">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-19">
          <h2 className="text-4xl md:text-5xl text-wc-dark mb-4" data-id="element-20">
            💰 RESUMEN DE LA OFERTA
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-3xl shadow-xl overflow-hidden border border-gray-200" data-id="element-21">
          <div className="overflow-x-auto" data-id="element-22">
            <table className="w-full min-w-[600px]" data-id="element-23">
              <thead data-id="element-24">
                <tr className="bg-gray-100" data-id="element-25">
                  <th className="p-6 text-left text-lg font-bold text-gray-600 border-b border-gray-200 w-1/2" data-id="element-26">
                    Características
                  </th>
                  <th className="p-6 text-center text-xl font-display text-wc-blue border-b border-gray-200 w-1/4" data-id="element-27">
                    PACK BÁSICO
                  </th>
                  <th className="p-6 text-center text-xl font-display text-wc-yellow bg-wc-dark border-b border-gray-800 w-1/4" data-id="element-28">
                    PACK HISTÓRICO ⭐
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-29">
                {features.map((feat, idx) => <tr key={idx} className={idx % 2 === 0 ? 'bg-white' : 'bg-gray-50'} data-id="element-30">
                    <td className="p-4 px-6 border-b border-gray-100 font-medium text-gray-800" data-id="element-31">
                      {feat.name}
                    </td>
                    <td className="p-4 border-b border-gray-100 text-center" data-id="element-32">
                      {feat.basic ? <Check className="w-6 h-6 text-green-500 mx-auto" data-id="element-33" /> : <X className="w-6 h-6 text-red-400 mx-auto" data-id="element-34" />}
                    </td>
                    <td className="p-4 border-b border-gray-100 text-center bg-gray-50/50" data-id="element-35">
                      {feat.history ? <Check className="w-6 h-6 text-green-500 mx-auto" data-id="element-36" /> : <X className="w-6 h-6 text-red-400 mx-auto" data-id="element-37" />}
                    </td>
                  </tr>)}
                <tr className="bg-gray-100" data-id="element-38">
                  <td className="p-6 font-bold text-gray-600 text-right" data-id="element-39">
                    PRECIO
                  </td>
                  <td className="p-6 text-center text-3xl font-display text-wc-blue" data-id="element-40">
                    $19.990
                  </td>
                  <td className="p-6 text-center text-3xl font-display text-wc-dark bg-wc-yellow" data-id="element-41">
                    $27.990
                  </td>
                </tr>
                <tr className="bg-white" data-id="element-42">
                  <td className="p-6" data-id="element-43"></td>
                  <td className="p-6 text-center" data-id="element-44">
                    <a href="https://www.digitalbibliotec.online/cart/52276163608858:1" target="_blank" rel="noopener noreferrer" className="inline-block bg-wc-blue hover:bg-blue-800 text-white font-bold py-3 px-6 rounded-lg w-full transition-colors" data-id="element-45">
                      🛒 QUIERO ESTE
                    </a>
                  </td>
                  <td className="p-6 text-center" data-id="element-46">
                    <a href="https://www.digitalbibliotec.online/cart/52276164100378:1" target="_blank" rel="noopener noreferrer" className="inline-block bg-wc-red hover:bg-red-700 text-white font-bold py-3 px-6 rounded-lg w-full transition-colors shadow-md" data-id="element-47">
                      👑 QUIERO ESTE
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </motion.div>
      </div>
    </section>;
}